// TODO: Can be moved to @assembly-web/ui as a DS primitive if needed.

import { useEffect, useRef, useState } from 'react';

import { TextStyle, type TextStyleProps } from '../Feedback/TextStyle';
import { Tooltip } from '../Feedback/Tooltip';

export function OverflowText(props: TextStyleProps & { tooltipText?: string }) {
  const { tooltipText, ...propsWithContent } = props;

  const [textOverflow, setTextOverflow] = useState(false);
  const textRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    const checkOverflow = () => {
      const current = textRef.current;
      if (current) {
        const isOverflowing = current.scrollHeight > current.clientHeight;
        setTextOverflow(isOverflowing);
      }
    };

    checkOverflow();

    window.addEventListener('resize', checkOverflow);
    return () => window.removeEventListener('resize', checkOverflow);
  }, []);

  return (
    <Tooltip tooltipText={Boolean(textOverflow) && tooltipText}>
      <TextStyle {...propsWithContent} ref={textRef} />
    </Tooltip>
  );
}
